import '@fullcalendar/core/vdom' // solves a Vite loading issue
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

export const calendarLoader = () => {
  const entryInfoElements = document.querySelectorAll('[data-entry-info]');
  const entries = Array.from(entryInfoElements).map(
    item => JSON.parse(item.dataset.entryInfo)
  );

  let eventObj = entries[0];

  let calendarEl = document.getElementById('calendar');
  let calendar = new Calendar(calendarEl, {
    plugins: [dayGridPlugin, listPlugin, timeGridPlugin],
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,listMonth'
    },
    events: eventObj
  });

  calendar.render();
};